module.exports = __webpack_public_path__ + "img/beachjar.8c3df2fc.jpg";